import type { ReactNode } from 'react';
import { Box, type BoxProps } from '@customerio/pluma-components/react';
import * as styles from '../styles.css';

export type PhonePreviewProps = {
  title: string;
  body: string;
  /**
   * Rendered inside the notification above its title, for the chrome a real one
   * carries — the sending app's name, the time it arrived.
   */
  header?: ReactNode;
  /**
   * Put on the notification card itself, for a caller that needs to recolour it
   * and everything inheriting from it.
   */
  notificationClassName?: string;
} & Omit<BoxProps, 'className'>;

/** A push notification as it lands on a device, cut off below the fold. */
export function PhonePreview({ title, body, header, notificationClassName, ...boxProps }: PhonePreviewProps) {
  const notificationClasses =
    notificationClassName == null ? styles.phoneNotification : `${styles.phoneNotification} ${notificationClassName}`;

  return (
    <Box {...boxProps} className={styles.phone}>
      <Box className={styles.phoneScreen}>
        <Box className={notificationClasses}>
          {header}
          <Box className={styles.phoneNotificationTitle}>{title}</Box>
          <Box className={styles.phoneNotificationBody}>{body}</Box>
        </Box>
      </Box>
    </Box>
  );
}
